module.exports = __webpack_public_path__ + "img/monibox.547bbe0a.svg";